import "core-js/modules/es6.string.small";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import times from 'lodash/times';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TrendParagraph from '~/components/molecules/Editorial/Trend/TrendParagraph.vue';
import TrendInspiration from '~/components/molecules/Editorial/Trend/TrendInspiration.vue';
export default {
  name: 'TrendComplementary',
  components: {
    TrendParagraph: TrendParagraph,
    TrendInspiration: TrendInspiration
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27;

      return {
        icon: ((_ref27 = this.payload) != null ? (_ref27 = _ref27.primary) != null ? _ref27.icon_name : _ref27 : _ref27) || '',
        background: ((_ref26 = this.payload) != null ? (_ref26 = _ref26.primary) != null ? _ref26.background_color : _ref26 : _ref26) || '',
        paragraph: {
          color: ((_ref25 = this.payload) != null ? (_ref25 = _ref25.primary) != null ? _ref25.initial_color : _ref25 : _ref25) || '',
          title: ((_ref24 = this.payload) != null ? (_ref24 = _ref24.primary) != null ? (_ref24 = _ref24.title) != null ? (_ref24 = _ref24[0]) != null ? _ref24.text : _ref24 : _ref24 : _ref24 : _ref24) || '',
          subtitle: ((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? (_ref23 = _ref23.description) != null ? (_ref23 = _ref23[0]) != null ? _ref23.text : _ref23 : _ref23 : _ref23 : _ref23) || '',
          button: {
            color: ((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? _ref22.button_color : _ref22 : _ref22) || '',
            text: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? _ref21.button_text : _ref21 : _ref21) || '',
            url: new UrlParse(((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? (_ref20 = _ref20.button_url) != null ? _ref20.url : _ref20 : _ref20 : _ref20) || '').pathname,
            tracking: {
              data: {
                event_category: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.event_category : _ref19 : _ref19) || '',
                event_action: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.event_action : _ref18 : _ref18) || '',
                event_label: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.event_label : _ref17 : _ref17) || ''
              }
            }
          },
          quote: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.quote : _ref16 : _ref16) || ''
        },
        images: times(4, Number).map(function (i) {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15;

          return {
            reference: ((_ref15 = _this.payload) != null ? (_ref15 = _ref15.items) != null ? (_ref15 = _ref15[i]) != null ? _ref15.reference : _ref15 : _ref15 : _ref15) || '',
            alt: ((_ref14 = _this.payload) != null ? (_ref14 = _ref14.items) != null ? (_ref14 = _ref14[i]) != null ? _ref14.alt : _ref14 : _ref14 : _ref14) || '',
            small: formatPrismicImage((_ref13 = _this.payload) != null ? (_ref13 = _ref13.items) != null ? (_ref13 = _ref13[i]) != null ? (_ref13 = _ref13.image) != null ? (_ref13 = _ref13.small) != null ? _ref13.url : _ref13 : _ref13 : _ref13 : _ref13 : _ref13, ['w_375']) || EMPTY_PIXEL,
            medium: formatPrismicImage((_ref12 = _this.payload) != null ? (_ref12 = _ref12.items) != null ? (_ref12 = _ref12[i]) != null ? (_ref12 = _ref12.image) != null ? (_ref12 = _ref12.small) != null ? _ref12.url : _ref12 : _ref12 : _ref12 : _ref12 : _ref12, ['w_375,dpr_2']) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref11 = _this.payload) != null ? (_ref11 = _ref11.items) != null ? (_ref11 = _ref11[i]) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.large) != null ? _ref11.url : _ref11 : _ref11 : _ref11 : _ref11 : _ref11, ['w_1440']) || EMPTY_PIXEL,
            xlarge: formatPrismicImage((_ref10 = _this.payload) != null ? (_ref10 = _ref10.items) != null ? (_ref10 = _ref10[i]) != null ? (_ref10 = _ref10.image) != null ? (_ref10 = _ref10.large) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10 : _ref10, ['w_1440,dpr_2']) || EMPTY_PIXEL,
            text: ((_ref9 = _this.payload) != null ? (_ref9 = _ref9.items) != null ? (_ref9 = _ref9[i]) != null ? _ref9.text : _ref9 : _ref9 : _ref9) || '',
            negativeText: _this.negative(((_ref8 = _this.payload) != null ? (_ref8 = _ref8.items) != null ? (_ref8 = _ref8[i]) != null ? _ref8.negative_text : _ref8 : _ref8 : _ref8) || ''),
            negativeIcon: _this.negative(((_ref7 = _this.payload) != null ? (_ref7 = _ref7.items) != null ? (_ref7 = _ref7[i]) != null ? _ref7.negative_icon : _ref7 : _ref7 : _ref7) || ''),
            layer: _this.typeLayer(((_ref6 = _this.payload) != null ? (_ref6 = _ref6.items) != null ? (_ref6 = _ref6[i]) != null ? _ref6.layer : _ref6 : _ref6 : _ref6) || ''),
            tracking: {
              data: {
                event_category: ((_ref5 = _this.payload) != null ? (_ref5 = _ref5.items) != null ? (_ref5 = _ref5[i]) != null ? _ref5.event_category : _ref5 : _ref5 : _ref5) || '',
                event_action: ((_ref4 = _this.payload) != null ? (_ref4 = _ref4.items) != null ? (_ref4 = _ref4[i]) != null ? _ref4.event_action : _ref4 : _ref4 : _ref4) || '',
                event_label: ((_ref3 = _this.payload) != null ? (_ref3 = _ref3.items) != null ? (_ref3 = _ref3[i]) != null ? _ref3.event_label : _ref3 : _ref3 : _ref3) || ''
              }
            },
            cinemagraph: {
              mp4: formatPrismicImage((_ref2 = _this.payload) != null ? (_ref2 = _ref2.items) != null ? (_ref2 = _ref2[i]) != null ? (_ref2 = _ref2.video_mp4) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2, [], '', 'video') || '',
              webm: formatPrismicImage((_ref = _this.payload) != null ? (_ref = _ref.items) != null ? (_ref = _ref[i]) != null ? (_ref = _ref.video_webm) != null ? _ref.url : _ref : _ref : _ref : _ref, [], '', 'video') || ''
            }
          };
        })
      };
    }
  },
  methods: {
    negative: function negative(arg) {
      return arg === 'black';
    },
    typeLayer: function typeLayer(arg) {
      return arg === 'no';
    }
  }
};